import { ApiPlatformEnum } from '@inter-ikea-kompis/enums';

import DexfConfiguration from '../../utilities/DexfConfiguration.js';
import IrwPlatformCommunication from '../../utilities/platform-communication/IrwPlatformCommunication.js';
import RoigPlatformCommunication from '../../utilities/platform-communication/RoigPlatformCommunication.js';
import type IPlatformServiceOptions from './IPlatformServiceOptions.js';

/**
 * This class is used as a interface for platform services.
 */
export default class PlatformService {
	private readonly applicationName: string;
	private readonly dexfConfiguration: DexfConfiguration;

	/**
	 * Constructor.
	 *
	 * @param options Options.
	 */
	constructor(options: IPlatformServiceOptions) {
		this.applicationName = options.applicationName;
		this.dexfConfiguration = new DexfConfiguration(options);
	}

	/**
	 * Sets the iframe container height.
	 *
	 * @param height Height in pixels.
	 * @returns Promise object.
	 */
	public async setIframeHeight(height: number): Promise<void> {
		const { kompis } = await this.dexfConfiguration.getSettings();

		switch (kompis.serviceSettings.apiPlatform) {
			case ApiPlatformEnum.roig:
				new RoigPlatformCommunication().setIframeHeight(height);
				break;
		}

		/* 
		Communicate via the standard API no matter what since we don't know if a 
		NIF/ROIG market has implemented the new one or not.
		*/
		new IrwPlatformCommunication({ applicationName: this.applicationName }).setIframeHeight(height);
	}
}
